import { orderDateStyles as styles } from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import { css } from "styled-components";

styles.titleText = {
    ...styles.titleText,
    css: css`
        font-size: 18px;
        margin-bottom: 4px;
    `,
};
